<template>
  <div class="circle-container" :style="{ width: size + 'px', height: size + 'px' }">
    <svg class="circle" viewBox="0 0 100 100">
      <circle
          class="bg"
          cx="50"
          cy="50"
          r="45"
          stroke-width="10"
          fill="none"
      />
      <circle
          class="progress"
          cx="50"
          cy="50"
          r="45"
          stroke-width="10"
          fill="none"
          :stroke="color"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="dashOffset"
          transform="rotate(-90 50 50)"
      />
    </svg>
    <div class="circle-text">
      {{ value }}%
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: { type: Number, required: true },
  size: { type: Number, default: 120 },
  color: { type: String, default: '#00bfff' }
})

const radius = 45
const circumference = 2 * Math.PI * radius

const dashOffset = computed(() => {
  const percent = Math.min(Math.max(props.value, 0), 100)
  return circumference * (1 - percent / 100)
})
</script>

<style scoped>
.circle-container {
  position: relative;
  display: inline-block;
}

.circle {
  width: 100%;
  height: 100%;
}

.bg {
  stroke: #eee;
}

.progress {
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease;
}

.circle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 1rem;
}
</style>
